import { useCallback } from 'react';
import { useStore } from '../store';
import { localSettingsStore } from '../settings/local';
import { translate, type StringKey, type UiLanguage } from './strings';

export function useUiLanguage(): UiLanguage {
  return useStore(localSettingsStore).uiLanguage;
}

export function useT(): (key: StringKey, params?: Record<string, string | number>) => string {
  const lang = useUiLanguage();
  return useCallback((key: StringKey, params?: Record<string, string | number>) => translate(lang, key, params), [lang]);
}
